import { render, staticRenderFns } from "./BusCaptainSetup.vue?vue&type=template&id=4effc107&scoped=true&"
import script from "./BusCaptainSetup.vue?vue&type=script&lang=js&"
export * from "./BusCaptainSetup.vue?vue&type=script&lang=js&"
import style0 from "./BusCaptainSetup.vue?vue&type=style&index=0&id=4effc107&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4effc107",
  null
  
)

export default component.exports